import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class PluginService {
  checkHasChromeExtension() {
    return (
      document.documentElement.getAttribute("extension-installed") === "true"
    );
  }

  checkBrowser() {
    return (window as any).chrome != null;
  }

  shouldShowPluginPrompt() {
    return !this.checkHasChromeExtension() || !this.checkBrowser();
  }
}
